import { useMutation } from '@tanstack/react-query';
import { DELETE_CART } from '@/constants/API';
import { axios } from '@/lib/axios';
import { clearCartOrderingType, removeCartStorage } from '@/utils/cart';
import { serializeObject } from '@/utils/object';
import storage from '@/utils/storage';

export type DeleteCartPayload = {
  version: number;
  cart_ref: string;
};

export const deleteCart = async (payload: DeleteCartPayload) => {
  const currentLocation = storage.getItem('currentLocation');

  const obj = {
    location_id: currentLocation.id,
    ...payload,
  };

  return await axios.delete<{
    success: boolean;
  }>(`${DELETE_CART}?${serializeObject(obj)}`);
};

export const useDeleteCart = () =>
  useMutation({
    onSuccess: () => {
      storage.removeItem('cart_ref');
      clearCartOrderingType();
      removeCartStorage();
    },
    mutationFn: deleteCart,
  });
